import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild
} from "@angular/core";
import { FileItem, FileUploader } from 'ng2-file-upload';

import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BaseAutoUploaderComponent } from "app/Core/Abstract/baseAutoUploader.component";
import { ConfigService } from "app/Core/Abstract/config.service";
import { EventsEmitterService } from "app/Core/Abstract/emitter.service";
import { LogService } from "app/Core/Abstract/log.service";
import { VisualsService } from "app/Core/Abstract/visuals.service";
import { SecurityService } from "app/Core/Security/security.service";
import { ModalDirective } from "ngx-bootstrap/modal";


@Component({
  selector: "inlinefileuploader",
  templateUrl: "inlinefileuploader.component.html",
  styleUrls: ["./inlinefileuploader.component.scss"]
})
export class InlineFileUploaderComponent extends BaseAutoUploaderComponent implements OnInit {
  
  @ViewChild("errorModal",{static: false}) public errorModal: ModalDirective;
  @ViewChild("fileUpload") fileUpload: any;
  @Input() submit: any;
  @Input() status: any;
  @Input() multiple: any;
  @Input() regCmpDocId: any;
  @Input() hasError;
  @Input() disable;
  downloadedTemplate = signal(false);
  docsList: any;
  private _pk: any;

  private _userId = "";

  @Input()
  set userId(name) {
    this._userId = name;
  }

  get userId() { return this._userId; }
  get pk(): any {
    return this._pk;
  }
  @Input("pk")
  set pk(value: any) {
    this._pk = value;
  
    //clear previous
    this.uploader.clearQueue();
  }

  @Output()
  refresh: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  getDocumentList: EventEmitter<any> = new EventEmitter<any>();

  protected continueWithSearch: boolean = true;
  constructor(
    protected securityService: SecurityService,
    protected configService: ConfigService,
    protected logger: LogService,
    protected visualsService: VisualsService,
    protected eventsEmitterService: EventsEmitterService,
    private cdf: ChangeDetectorRef,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) {
    super(
      securityService,
      configService,
      logger,
      visualsService,
      eventsEmitterService
    );
    this.getVisuals();
    
    this.docsList = this.visualsService.getLkpFromStorageAsJSON(
      "LKP_REGCMP_DOCUMENT_I_DOC_ID",
      true
    );
    this.eventsEmitterService.languageChange.subscribe(langId => {
      this.getVisuals();
      this.docsList = this.visualsService.getLkpFromStorageAsJSON(
        "LKP_REGCMP_DOCUMENT_I_DOC_ID",
        true
      );
    });
  }

  protected initLoader() {
    this.group = "uploadFiles";
    this.URL = this.configService.getServer() + "FileUploadService/uploadFile";
    this.displayAllowedMimeType = [ "pdf","text","jpeg","png","powerpoint","excel","word"]
    this.allowedMimeType = [
      "application/pdf",
      "text/plain",
      "image/jpeg",
      "image/png",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-powerpoint",
      "application/msword",
      "application/vnd.ms-excel"
    ];
    this.uploader = new FileUploader({
      url: this.URL,
      authToken:
        "Bearer " + this.securityService.getFromStorage("access_token"),
      allowedMimeType: this.allowedMimeType,
      maxFileSize: this.getMaxFileSize(),
      queueLimit: this.queueLimit
    });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append("docId", encodeURI(this._pk["docId"] ? this._pk["docId"] : null));
      form.append("userId", this._userId);
      if (this._pk["comments"]) {
        form.append("comments", this._pk["comments"]);
      }
    };
    this.uploader.onErrorItem = (item, response, status, headers) =>
      this.onErrorItem(item, response, status, headers);
  }
  onErrorItem(
    item: FileItem,
    response: string,
    status: number,
    headers: any,
  ): any {
    this.uploading = false;
    this.uploader.removeFromQueue(item);
    this.cdf.detectChanges();
    const message = this.extractResponseMessage(response);
    LogService.emitAlert({
      type: "danger",
      body: message,
    });

}
  private download(id: number,fileName: string) {
    this.visualsService.downloadFile(id,fileName,this._userId).subscribe(
      data => {
        this.logger.log("Downloaded file");
      },
      error => {
        this.logger.log("Error Dowloading file");
      }
    );
  }
  private preview(id: number,fileName: string) {
    let authToken="Bearer " + this.securityService.getFromStorage("access_token")
    this.visualsService.previewFile(id, fileName, this._userId).subscribe(
      data => {

        const  objectUrl= URL.createObjectURL(data);
        const popup = window.open(objectUrl, '_blank', 'width=800,height=600');
        setTimeout(() => {
          URL.revokeObjectURL(objectUrl); // Clean up
        }, 1000); 
        
        if (!popup) {
          alert('Popup blocked! Please allow popups for this site.');
        }
        this.logger.log("Downloaded file and created URL");
      },
      error => {
        this.logger.log("Error downloading file");
      }
    );
  }


  private downloadTemplate(hasTemplate: string ,templateFileName: string,templateFileExt: string){
    this.visualsService.downloadTemplateFile(hasTemplate,templateFileName,templateFileExt,this.userId,this._pk.docId).subscribe(
      response => {
        this.downloadedTemplate.set(true);
      },
      error => {
        this.logger.log("Error Dowloading Template");
      }
    );
  }

  private deleteFile(regcmpdocId: number) {
    this.visualsService.deleteFile(regcmpdocId).subscribe(
      data => {
        this.logger.log("deleted file");
        this.refresh.emit(regcmpdocId);
      },
      error => {
        this.logger.log("Error deleting file");
      }
    );
  }
  private extractResponseMessage(res: string): string {
    let message;
    try {
      message = JSON.parse(res);
    } catch (e) {
      message = res;
    }
    if (message && message.hasOwnProperty("message")) {
      message = message.message;
    }
    return message || "";
  }
  public uploadSuccessCallback() {
    this.refresh.emit();
  }

  isSupportedFileType(fileName: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
    return fileName.toLowerCase().endsWith('.txt') || 
           fileName.toLowerCase().endsWith('.pdf') || 
           imageExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
  }
}
